import { SocialLinks } from "@/components/common";
import { Link } from "@/i18n/routing";
import {
  IconCompanyInfo,
  IconTalkToUs,
  IconWriteToUs,
} from "@repo/assets/images";
import { Logo } from "@repo/components";
import { getStrapiMedia } from "@repo/lib/utils";
import { getTranslations } from "next-intl/server";
import Image from "next/image";

const Footer = async ({ footer }) => {
  const t = await getTranslations("Common");
  const footerLogo = footer?.FooterLogo;
  const footerMenu = footer?.FooterMenu;
  const footerSocialLinks = footer?.SocialLinks;

  return (
    <footer className="bg-supportiveBlack p-6 md:pb-7 md:pt-20">
      <div className="mx-auto text-sm md:max-w-screen-xl">
        <div className="flex flex-col border-b border-[#313131] md:flex-row md:pb-8">
          <div className="pb-6 md:me-16 md:pb-0">
            <div className="max-w-[120px]">
              {footerLogo?.image?.url ? (
                <Link title={footerLogo.image.alternativeText} href="/">
                  <Image
                    src={getStrapiMedia(footerLogo.image.url)}
                    alt={footerLogo.image.alternativeText}
                    width={footerLogo.image.width}
                    height={footerLogo.image.height}
                    className="w-[120px]"
                  />
                </Link>
              ) : (
                <Logo />
              )}
            </div>
            {footerLogo?.description && (
              <p className="max-w-[328px] pt-4 text-xs font-normal text-white md:text-sm md:font-semibold rtl:font-normal">
                {footerLogo.description}
              </p>
            )}
          </div>
          <div className="flex-1">
            <div className="flex flex-wrap gap-8 pb-4 md:flex-nowrap md:justify-end md:gap-x-4">
              {footerMenu?.map((item) => (
                <div key={item.id} className="min-w-[200px] max-w-[250px] grow">
                  <span className="block py-1 font-medium text-white">
                    {item.heading}
                  </span>
                  <ul className="text-supportiveDarkGray">
                    {item?.FooterLinks?.map((link) => (
                      <li key={link.id}>
                        <Link
                          href={link.url}
                          className="inline-block py-1 transition-colors duration-200 hover:underline md:py-1.5"
                        >
                          {link.text}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

              {/* Contact Section */}
              <div className="min-w-[200px] max-w-[250px] grow">
                <span className="block pb-2 pt-1 font-medium text-white">
                  {t("Contact")}
                </span>
                <div className="space-y-4">
                  {footer?.address && (
                    <div className="flex items-center space-x-4 rtl:space-x-reverse">
                      <span className="shrink-0">
                        <IconCompanyInfo />
                      </span>
                      <span className="text-supportiveDarkGray">
                        {footer?.address}
                      </span>
                    </div>
                  )}
                  {footer?.email && (
                    <a
                      href={`mailto:${footer?.email}`}
                      target="_blank"
                      className="flex items-center space-x-4 rtl:space-x-reverse"
                      rel="noreferrer"
                    >
                      <span className="shrink-0">
                        <IconWriteToUs />
                      </span>
                      <span className="text-supportiveDarkGray">
                        {footer?.email}
                      </span>
                    </a>
                  )}
                  {footer?.phone && (
                    <a
                      href={`tel:${footer?.phone}`}
                      target="_blank"
                      className="flex items-center space-x-4 rtl:space-x-reverse"
                      rel="noreferrer"
                    >
                      <span className="shrink-0">
                        <IconTalkToUs />
                      </span>
                      <span className="text-supportiveDarkGray" dir="ltr">
                        {footer?.phone}
                      </span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col pt-6 md:flex md:flex-row md:items-center">
          <div className="order-last mb-4 md:order-none md:mb-0">
            {footer?.copyright && (
              <p className="pt-2 text-[#B8B8B8]">{footer?.copyright}</p>
            )}
          </div>
          <div className="mb-4 md:mb-0 md:ms-auto">
            <SocialLinks socialLinks={footerSocialLinks} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
